'use strict';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||!1;descriptor.configurable=!0;if('value'in descriptor)descriptor.writable=!0;Object.defineProperty(target,descriptor.key,descriptor)}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor}}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError('Cannot call a class as a function')}}

const _=require('pulsar-utils/dist-es6/_');
const AngularHelpers=require('../../../../dist-es6/client/angularCommon/angularHelpers');
const LoadUrlMatcherTypes=require('../../../../dist-es6/client/services/paramSyncService').LoadUrlMatcherTypes;
const TimeInterval=require('pulsar-utils/dist-es6/timeInterval');let

FatigueReportConfig=function(){_createClass(FatigueReportConfig,null,[{key:'$inject',get:function()
{return['$stateProvider','$urlMatcherFactoryProvider']}}]);

function FatigueReportConfig($stateProvider,$urlMatcherFactoryProvider){_classCallCheck(this,FatigueReportConfig);
LoadUrlMatcherTypes($urlMatcherFactoryProvider);
let feature=AngularHelpers.generateAuthenticatedFeatureConfig('fatigueReport',{
url:'/fatigueReport?{id:GuidString}&{employeeId:string}&{interval:TimeInterval}&{timezone:Timezone}',
reloadOnSearch:!1,
views:{
"header@":{
templateUrl:null},

"breadcrumbs@":{
templateUrl:`/templates/layout/breadcrumbs`}}});



$stateProvider.state(feature.fullName,feature.config);
}return FatigueReportConfig}();


module.exports=FatigueReportConfig;
//# sourceMappingURL=fatigueReportConfig.js.map
